import React from 'react';
import parse from 'react-html-parser';

import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';

export interface MetricExplanationPopupProps {
  title: string;
  htmlBody: string;
  isPopupOpen: boolean;
  handleClose: () => void;
}

export const MetricExplanationPopup = ({
  title,
  htmlBody,
  isPopupOpen,
  handleClose,
}: MetricExplanationPopupProps) => {
  return (
    <Dialog onClose={handleClose} open={isPopupOpen}>
      <DialogTitle sx={{ m: 0, p: 2 }}>{title}</DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>{parse(htmlBody)}</DialogContent>
    </Dialog>
  );
};
